import axios from "axios";
import Constants from "../../../components.constants.js";

export default {

    async getRetrieveSettingsDetailsFromServer(context, payload = {}) {
        try {
            let resp = await axios.get(`${Constants.settingsUrl}/retrieval`, payload);
            if (Constants.acceptedStatusCodes.includes(Number(resp.status))) {
                resp.data.statusCode = resp.status
                return resp.data;
            } else {
                throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
            }
        } catch (error) {
            console.error(
                `[getRetrieveSettingsDetailsFromServer][Store][Error occured while getting tags List--->${error}]`
            );
            if (error.response) {
                if (error.response.status == 401) {
                    return context.dispatch("users/logOutFromServer", {}, { root: true })
                } else {
                    error.response.data.statusCode = error.response.status
                    return error.response.data
                }
            }
            return {}
        }
    },

    async updateReportsSettings(context, payload = {}) {
        try {
            let resp = await axios.put(`${Constants.settingsUrl}/reports/`+payload._id, payload);
            if (Constants.acceptedStatusCodes.includes(resp.status)) {
                console.log(
                    `[updateReportsSettings][Store][User update resp-->${resp.status}]`
                );
                resp.data.statusCode = resp.status
                    // if (payload.params._id == context.state.loggedInUserInfo._id) {
                    //     context.dispatch("updateLoggedInUserInfo", {})
                    // }
                return resp.data;
            } else {
                throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
            }
        } catch (error) {
            console.error(
                `[updateReportsSettings][Store][Error occured while updating user--->${error}]`
            );
            if (error.response) {
                if (error.response.status == 401) {
                    return context.dispatch("logOutFromServer")
                } else {
                    error.response.data.statusCode = error.response.status
                    return error.response.data
                }
            }
            return {}
        }
    },

    async addNewPramsInReportSettings(context, payload = {}) {
            try {
                let resp = await axios.post(`${Constants.settingsUrl}/reports`, payload);
                if (Constants.acceptedStatusCodes.includes(resp.status)) {
                    console.log(
                        `[addNewPramsInReportSettings][Store][Posted request Status : -->${resp.status}]`
                    );
                    return resp.data.path;
                } else {
                    throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
                }
            } catch (error) {
                console.error(
                    `[addNewPramsInReportSettings][Store][Error occured while uploading file to proxy location --->${error}]`
                );
                alert("Error occured while uploading file to proxy location")
                if (error.response) {
                    error.response.data.statusCode = error.response.status
                    return error.response.data
                }
                return ""
            }
    },

    async getReportsSettingsData(context, payload = {}) {
        try {
            let resp = await axios.get(`${Constants.settingsUrl}/reports`, payload);
            if (Constants.acceptedStatusCodes.includes(Number(resp.status))) {
                resp.data.statusCode = resp.status
                return resp.data;
            } else {
                throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
            }
        } catch (error) {
            console.error(
                `[getReportsSettingsData][Store][Error occured while getting tags List--->${error}]`
            );
            if (error.response) {
                if (error.response.status == 401) {
                    return context.dispatch("users/logOutFromServer", {}, { root: true })
                } else {
                    error.response.data.statusCode = error.response.status
                    return error.response.data
                }
            }
            return {}
        }
    },
    async getLicensesListFromServer(context, payload = {}) {
        try {
            let resp = await axios.get(Constants.licenseUrl, payload);
            if (Constants.acceptedStatusCodes.includes(Number(resp.status))) {
                resp.data.statusCode = resp.status
                return resp.data;
            } else {
                throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
            }
        } catch (error) {
            console.error(
                `[getLicenseDetailsFromServer][Store][Error occured while getting licenses List--->${error}]`
            );
            if (error.response) {
                if (error.response.status == 401) {
                    return context.dispatch("users/logOutFromServer", {}, { root: true })
                } else {
                    error.response.data.statusCode = error.response.status
                    return error.response.data
                }
            }
            return {}
        }
    },
    async getLicensedSystemInfoDetailsFromServer(context, payload = {}) {
        try {
            let resp = await axios.get(Constants.licensedSystemInfoUrl, payload);
            return resp;
        } catch (error) {
            console.error(
                `[getLicensedSystemInfoDetailsFromServer][Store][Error occured while getting licensed system info details--->${error}]`
            );
            if (error.response) {
                if (error.response.status == 401) {
                    return context.dispatch("users/logOutFromServer", {}, { root: true })
                } else {
                    error.response.data.statusCode = error.response.status
                    return error.response.data
                }
            }
            return {}
        }
    },
    async getPathOfUploadedFile(context, payload = {}) {
        try {
            let resp = await axios.post(`${Constants.uploadLicensedInfoUrl}`, payload);
            if (Constants.acceptedStatusCodes.includes(resp.status)) {
                console.log(
                    `[getPathOfUploadedFile][Store][Posted request Status : -->${resp.status}]`
                );
                return resp.data.path;
            } else {
                throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
            }
        } catch (error) {
            console.error(
                `[getPathOfUploadedFile][Store][Error occured while uploading file to proxy location --->${error}]`
            );
            alert("Error occured while uploading file to proxy location")
            if (error.response) {
                error.response.data.statusCode = error.response.status
                return error.response.data
            }
            return ""
        }
    },
    async getPathOfSublicenseUploadedFile(context, payload = {}) {
        try {
            let resp = await axios.post(`${Constants.licenseUrl+"/"+payload.licenseId}`, payload.params);
            if (Constants.acceptedStatusCodes.includes(resp.status)) {
                resp.data.statusCode = resp.status;
                console.log(
                    `[getPathOfSublicenseUploadedFile][Store][Posted request Status : -->${resp.status}]`
                );
                return resp.data;
            } else {
                throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
            }
        } catch (error) {
            console.error(
                `[getPathOfSublicenseUploadedFile][Store][Error occured while uploading file to proxy location --->${error}]`
            );
            alert("Error occured while uploading file to proxy location")
            if (error.response) {
                error.response.data.statusCode = error.response.status
                return error.response.data
            }
            return ""
        }
    },
    
    async getAdobePluginLicenseDatafromServer(context, payload = {}) {
        try {
            let resp = await axios.get(`${Constants.licenseUrl}/adobe`, payload);
            if (Constants.acceptedStatusCodes.includes(resp.status)) {
                resp.data.statusCode = resp.status
                return resp.data;
            } else {
                throw `getAdobePluginLicenseDatafromServer Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
            }
        } catch (error) {
            console.error(
                `[getAdobePluginLicenseDatafromServer][Store][Error occured while getting tags List--->${error}]`
            );
            if (error.response) {
                if (error.response.status == 401) {
                    return context.dispatch("users/logOutFromServer", {}, { root: true })
                } else {
                    error.response.data.statusCode = error.response.status
                    return error.response.data
                }
            }
            return {}
        }
    },
    
    async getArchiveStorageLicenseDatafromServer(context, payload = {}) {
        try {
            let resp = await axios.get(`${Constants.licenseUrl}/archive`, payload);
            if (Constants.acceptedStatusCodes.includes(resp.status)) {
                resp.data.statusCode = resp.status
                return resp.data;
            } else {
                throw `getArchiveStorageLicenseDatafromServer Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
            }
        } catch (error) {
            console.error(
                `[getArchiveStorageLicenseDatafromServer][Store][Error occured while getting tags List--->${error}]`
            );
            if (error.response) {
                if (error.response.status == 401) {
                    return context.dispatch("users/logOutFromServer", {}, { root: true })
                } else {
                    error.response.data.statusCode = error.response.status
                    return error.response.data
                }
            }
            return {}
        }
    },

    async updateAdobePluginUsersfromServer(context, payload = {}) {
        try {
            let resp = await axios.put(`${Constants.licenseUrl}/${payload.licenseId}`, payload.params);
            if (Constants.acceptedStatusCodes.includes(resp.status)) {
                console.log(
                    `[updateAdobePluginUsersfromServer][Store][User update resp-->${resp.status}]`
                );
                resp.data.statusCode = resp.status
                    // if (payload.params._id == context.state.loggedInUserInfo._id) {
                    //     context.dispatch("updateLoggedInUserInfo", {})
                    // }
                return resp.data;
            } else {
                throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
            }
        } catch (error) {
            console.error(
                `[updateAdobePluginUsersfromServer][Store][Error occured while updating user--->${error}]`
            );
            if (error.response) {
                if (error.response.status == 401) {
                    return context.dispatch("logOutFromServer")
                } else {
                    error.response.data.statusCode = error.response.status
                    return error.response.data
                }
            }
            return {}
        }
    },

    async uploadLicenseInfoToServer(context, payload = {}) {
        try {
            let resp = await axios.post(Constants.uploadLicensedInfoUrl, payload);
            if (Constants.acceptedStatusCodes.includes(resp.status)) {
                console.log(
                    `[uploadLicenseInfoToServer][Store][Upload job post resp-->${resp.status}]`
                );
                resp.data.statusCode = resp.status
                return resp.data;
            } else {
                throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
            }
        } catch (error) {
            console.error(
                `[uploadLicenseInfoToServer][Store][Error occured while Posting license upload job--->${error}]`
            );
            if (error.response) {
                if (error.response.status == 401) {
                    return context.dispatch("users/logOutFromServer", {}, { root: true })
                } else {
                    error.response.data.statusCode = error.response.status
                    return error.response.data
                }
            }
            return {}
        }

    },

    async updateSettingsKeys(context, payload = {}) {
        try {
            let resp = await axios.put(`${Constants.settingsUrl}/retrieval/${payload._id}`, payload);
            if (Constants.acceptedStatusCodes.includes(resp.status)) {
                console.log(
                    `[updateSettingsKeys][Store][User update resp-->${resp.status}]`
                );
                resp.data.statusCode = resp.status
                    // if (payload.params._id == context.state.loggedInUserInfo._id) {
                    //     context.dispatch("updateLoggedInUserInfo", {})
                    // }
                return resp.data;
            } else {
                throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
            }
        } catch (error) {
            console.error(
                `[updateSettingsKeys][Store][Error occured while updating user--->${error}]`
            );
            if (error.response) {
                if (error.response.status == 401) {
                    return context.dispatch("logOutFromServer")
                } else {
                    error.response.data.statusCode = error.response.status
                    return error.response.data
                }
            }
            return {}
        }
    },

    async getUploadSettingsDetailsFromServer(context, payload = {}) {
        try {
            let resp = await axios.get(`${Constants.settingsUrl}/upload`, payload);
            if (Constants.acceptedStatusCodes.includes(resp.status)) {
                resp.data.statusCode = resp.status
                return resp.data;
            } else {
                throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
            }
        } catch (error) {
            console.error(
                `[getUploadSettingsDetailsFromServer][Store][Error occured while getting tags List--->${error}]`
            );
            if (error.response) {
                if (error.response.status == 401) {
                    return context.dispatch("users/logOutFromServer", {}, { root: true })
                } else {
                    error.response.data.statusCode = error.response.status
                    return error.response.data
                }
            }
            return {}
        }
    },

    async updateUploadSettingsKeys(context, payload = {}) {
        try {
            let resp = await axios.put(`${Constants.settingsUrl}/upload/${payload._id}`, payload);
            console.log("payloadpayload", payload, resp)
            if (Constants.acceptedStatusCodes.includes(resp.status)) {
                console.log(
                    `[updateUploadSettingsKeys][Store][User update resp-->${resp.status}]`
                );
                resp.data.statusCode = resp.status
                    // if (payload.params._id == context.state.loggedInUserInfo._id) {
                    //     context.dispatch("updateLoggedInUserInfo", {})
                    // }
                return resp.data;
            } else {
                throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
            }
        } catch (error) {
            console.error(
                `[updateUploadSettingsKeys][Store][Error occured while updating user--->${error}]`
            );
            if (error.response) {
                if (error.response.status == 401) {
                    return context.dispatch("logOutFromServer")
                } else {
                    error.response.data.statusCode = error.response.status
                    return error.response.data
                }
            }
            return {}
        }
    },

    async getSystemInfoFromServer(context, payload = {}) {
        try {
            let resp = await axios.get(`${Constants.systemInfoUrl}`, payload);
            if (Constants.acceptedStatusCodes.includes(resp.status)) {
                resp.data.statusCode = resp.status
                return resp.data;
            } else {
                throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
            }
        } catch (error) {
            console.error(
                `[getSystemInfoFromServer][Store][Error occured while getting system info List--->${error}]`
            );
            if (error.response) {
                if (error.response.status == 401) {
                    return context.dispatch("users/logOutFromServer", {}, { root: true })
                } else {
                    error.response.data.statusCode = error.response.status
                    return error.response.data
                }
            }
            return {}
        }
    },

    async getGlobalSettingsDetailsFromServer(context, payload = {}) {
        try {
            let resp = await axios.get(`${Constants.settingsUrl}/global`, payload);
            if (Constants.acceptedStatusCodes.includes(Number(resp.status))) {
                resp.data.statusCode = resp.status
                return resp.data;
            } else {
                throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
            }
        } catch (error) {
            console.error(
                `[getGlobalSettingsDetailsFromServer][Store][Error occured while getting tags List--->${error}]`
            );
            if (error.response) {
                if (error.response.status == 401) {
                    return context.dispatch("users/logOutFromServer", {}, { root: true })
                } else {
                    error.response.data.statusCode = error.response.status
                    return error.response.data
                }
            }
            return {}
        }
    },
    async getGlobalSearchSettingsDetailsFromServer(context, payload = {}) {
        try {
            let resp = await axios.get(`${Constants.settingsUrl}/search`, payload);
            if (Constants.acceptedStatusCodes.includes(Number(resp.status))) {
                resp.data.statusCode = resp.status
                return resp.data;
            } else {
                throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
            }
        } catch (error) {
            console.error(
                `[getGlobalSearchSettingsDetailsFromServer][Store][Error occured while getting Search configuration details--->${error}]`
            );
            if (error.response) {
                if (error.response.status == 401) {
                    return context.dispatch("users/logOutFromServer", {}, { root: true })
                } else {
                    error.response.data.statusCode = error.response.status
                    return error.response.data
                }
            }
            return {}
        }
    },
    async updateGlobalSearchSettingsKeys(context, payload = {}) {
        try {
            let resp = await axios.put(`${Constants.settingsUrl}/search/${payload._id}`, payload);
            console.log("updateGlobalSearchSettingsKeys payload:", payload, resp)
            if (Constants.acceptedStatusCodes.includes(resp.status)) {
                console.log(
                    `[updateGlobalSearchSettingsKeys][Store][User update resp-->${resp.status}]`
                );
                resp.data.statusCode = resp.status
                return resp.data;
            } else {
                throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
            }
        } catch (error) {
            console.error(
                `[updateGlobalSearchSettingsKeys][Store][Error occured while updating search configurations--->${error}]`
            );
            if (error.response) {
                if (error.response.status == 401) {
                    return context.dispatch("logOutFromServer")
                } else {
                    error.response.data.statusCode = error.response.status
                    return error.response.data
                }
            }
            return {}
        }
    },

    async getDateTimeFormatsDropdownValuesFromServer(context, payload = {}) {
        try {
            let resp = await axios.get(`${Constants.settingsUrl}/global/date_time/datetime_format`, payload);
            if (Constants.acceptedStatusCodes.includes(Number(resp.status))) {
                resp.data.statusCode = resp.status
                return resp.data;
            } else {
                throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
            }
        } catch (error) {
            console.error(
                `[getDateTimeFormatsDropdownValuesFromServer][Store][Error occured while getting tags List--->${error}]`
            );
            if (error.response) {
                if (error.response.status == 401) {
                    return context.dispatch("users/logOutFromServer", {}, { root: true })
                } else {
                    error.response.data.statusCode = error.response.status
                    return error.response.data
                }
            }
            return {}
        }
    },

    async getDateFormatsDropdownValuesFromServer(context, payload = {}) {
        try {
            let resp = await axios.get(`${Constants.settingsUrl}/global/date_time/date_format`, payload);
            if (Constants.acceptedStatusCodes.includes(Number(resp.status))) {
                resp.data.statusCode = resp.status
                return resp.data;
            } else {
                throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
            }
        } catch (error) {
            console.error(
                `[getDateFormatsDropdownValuesFromServer][Store][Error occured while getting tags List--->${error}]`
            );
            if (error.response) {
                if (error.response.status == 401) {
                    return context.dispatch("users/logOutFromServer", {}, { root: true })
                } else {
                    error.response.data.statusCode = error.response.status
                    return error.response.data
                }
            }
            return {}
        }
    },

    async getTimezonesDropdownValuesFromServer(context, payload = {}) {
        try {
            let resp = await axios.get(`${Constants.settingsUrl}/global/date_time/time_zones`, payload);
            if (Constants.acceptedStatusCodes.includes(Number(resp.status))) {
                resp.data.statusCode = resp.status
                return resp.data;
            } else {
                throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
            }
        } catch (error) {
            console.error(
                `[getTimezonesDropdownValuesFromServer][Store][Error occured while getting tags List--->${error}]`
            );
            if (error.response) {
                if (error.response.status == 401) {
                    return context.dispatch("users/logOutFromServer", {}, { root: true })
                } else {
                    error.response.data.statusCode = error.response.status
                    return error.response.data
                }
            }
            return {}
        }
    },

    async gethardSubclipsConfigKeys(context, payload = {}) {
        try {
            let resp = await axios.get(`${Constants.settingsUrl}/subclip`, payload);
            if (Constants.acceptedStatusCodes.includes(Number(resp.status))) {
                resp.data.statusCode = resp.status
                return resp.data;
            } else {
                throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
            }
        } catch (error) {
            console.error(
                `[gethardSubclipsConfigKeys][Store][Error occured while getting hard subclips config info--->${error}]`
            );
            if (error.response) {
                if (error.response.status == 401) {
                    return context.dispatch("users/logOutFromServer", {}, { root: true })
                } else {
                    error.response.data.statusCode = error.response.status
                    return error.response.data
                }
            }
            return {}
        }
    },

    async getElasticReindexStatus(context, payload = {}) {
        try {
            let resp = await axios.get(`${Constants.elasticReindexStatus}`, payload);
            if (Constants.acceptedStatusCodes.includes(resp.status)) {
                resp.data.statusCode = resp.status
                return resp.data;
            } else {
                throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
            }
        } catch (error) {
            console.error(
                `[getElasticReindexStatus][Store][Error occured while getting tags List--->${error}]`
                );
                if (error.response) {
                    if (error.response.status == 401) {
                        return context.dispatch("users/logOutFromServer", {}, { root: true })
                    } else {
                        error.response.data.statusCode = error.response.status
                        return error.response.data
                    }
                }
                return {}
            }
        },

    async updateGlobalSettingsKeys(context, payload = {}) {
        try {
            let resp = await axios.put(`${Constants.settingsUrl}/global/${payload._id}`, payload);
            console.log("payloadpayload", payload, resp)
            if (Constants.acceptedStatusCodes.includes(resp.status)) {
                console.log(
                    `[updateGlobalSettingsKeys][Store][User update resp-->${resp.status}]`
                );
                resp.data.statusCode = resp.status
                    // if (payload.params._id == context.state.loggedInUserInfo._id) {
                    //     context.dispatch("updateLoggedInUserInfo", {})
                    // }
                return resp.data;
            } else {
                throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
            }
        } catch (error) {
            console.error(
                `[updateGlobalSettingsKeys][Store][Error occured while updating user--->${error}]`
            );
            if (error.response) {
                if (error.response.status == 401) {
                    return context.dispatch("logOutFromServer")
                } else {
                    error.response.data.statusCode = error.response.status
                    return error.response.data
                }
            }
            return {}
        }
    },
    async updateSubclipsGlobalKeys(context, payload = {}) {
        try {
            let resp = await axios.put(`${Constants.settingsUrl}/subclip/${payload._id}`, payload);
            if (Constants.acceptedStatusCodes.includes(resp.status)) {
                console.log(
                    `[updateSubclipsGlobalKeys][Store][User update resp-->${resp.status}]`
                );
                resp.data.statusCode = resp.status
                return resp.data;
            } else {
                throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
            }
        } catch (error) {
            console.error(
                `[updateSubclipsGlobalKeys][Store][Error occured while updating Subclips global settings--->${error}]`
            );
            if (error.response) {
                if (error.response.status == 401) {
                    return context.dispatch("logOutFromServer")
                } else {
                    error.response.data.statusCode = error.response.status
                    return error.response.data
                }
            }
            return {}
        }
    },
    async getConfiguredTranscoderProfilesFromServer(context, payload = {}){
        try{
            let resp = await axios.get(Constants.configuredTranscoderProfilesUrl, payload);
            if (Constants.acceptedStatusCodes.includes(Number(resp.status))) {
                resp.data.statusCode = resp.status
                return resp.data;
            } else {
                throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
            }
        }catch(error){
            console.error(
                `[getConfiguredTranscoderProfilesFromServer][Store][Error occured while getting transcoder profiles info--->${error}]`
              );
            if (error.response) {
                if (error.response.status == 401){
                  return context.dispatch("users/logOutFromServer", {},{root:true})
                }
                else {
                  error.response.data.statusCode = error.response.status
                  return error.response.data
                }
              }
             throw new Error([]);
        }
    },

    async getClientAccessTokenStatus(context, payload = {}) {
        try {
            let resp = await axios.get(Constants.clientAccessTokenStatus, payload);
            return resp;
        } catch (error) {
            console.error(
                `[getClientAccessTokenStatus][Store][Error occured while getClientAccessTokenStatus details--->${error}]`
            );
            if (error.response) {
                if (error.response.status == 401) {
                    return context.dispatch("users/logOutFromServer", {}, { root: true })
                } else {
                    error.response.data.statusCode = error.response.status
                    return error.response.data
                }
            }
            return {}
        }
    },

    async createClientAccessToken(context, payload = {}) {
        try {
            let resp = await axios.post(Constants.clientAccessToken, payload);
            if (Constants.acceptedStatusCodes.includes(resp.status)) {
                console.log(
                    `[createClientAccessToken][Store][Upload job post resp-->${resp.status}]`
                );
                resp.data.statusCode = resp.status
                return resp.data;
            } else {
                throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
            }
        } catch (error) {
            console.error(
                `[createClientAccessToken][Store][Error occured while Posting createClientAccessToken--->${error}]`
            );
            if (error.response) {
                if (error.response.status == 401) {
                    return context.dispatch("users/logOutFromServer", {}, { root: true })
                } else {
                    error.response.data.statusCode = error.response.status
                    return error.response.data
                }
            }
            return {}
        }
    },

    async deleteClientAccessToken(context, payload = {}) {
        try {
          let resp = await axios.delete(`${Constants.clientAccessToken}/${payload.id}`, payload);
          if (Constants.acceptedStatusCodes.includes(resp.status)) {
            console.log(
              `[deleteClientAccessToken][Store][Delete resp-->${resp.status}]`
            );
            resp.data.statusCode = resp.status
            return resp.data;
          } else {
            throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
          }
        } catch (error) {
          console.error(
            `[deleteClientAccessToken][Store][Error occured while updating access token--->${error}]`
          );
          if (error.response) {
            if (error.response.status == 401){
              return context.dispatch("logOutFromServer")
            }
            else {
              error.response.data.statusCode = error.response.status
              return error.response.data
            }
          }
          return {}
        }
      },

    async getAllAccessTokens(context, payload = {}) {
        try {
            let resp = await axios.get(Constants.clientAccessToken, payload);
            return resp;
        } catch (error) {
            console.error(
                `[getAllAccessTokens][Store][Error occured while getAllAccessTokens details--->${error}]`
            );
            if (error.response) {
                if (error.response.status == 401) {
                    return context.dispatch("users/logOutFromServer", {}, { root: true })
                } else {
                    error.response.data.statusCode = error.response.status
                    return error.response.data
                }
            }
            return {}
        }
    },

    async updateClientAccessToken(context, payload = {}) {
        try {
            let resp = await axios.put(Constants.clientAccessToken+"/"+payload._id, payload);
            if (Constants.acceptedStatusCodes.includes(resp.status)) {
                resp.data.statusCode = resp.status
                return resp.data;
            } else {
                throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
            }
        } catch (error) {
            console.error(
                `[updateClientAccessToken][Store][Error occured while updateClientAccessToken--->${error}]`
            );
            if (error.response) {
                if (error.response.status == 401) {
                    return context.dispatch("logOutFromServer")
                } else {
                    error.response.data.statusCode = error.response.status
                    return error.response.data
                }
            }
            return {}
        }
      },

    async getlangaugesDetailsFromServer(context, payload = {}) {
        try {
            let url = `${Constants.allLanguagesURL}`;
            if('enabled' in payload){
                url = url+"?enabled=true";
            }
            let resp = await axios.get(url, payload);
            if (Constants.acceptedStatusCodes.includes(resp.status)) {
                resp.data.statusCode = resp.status
                return resp.data;
            } else {
                throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
            }
        } catch (error) {
            console.error(
                `[getlangaugesDetailsFromServer][Store][Error occured while getting tags List--->${error}]`
            );
            if (error.response) {
                if (error.response.status == 401) {
                    return context.dispatch("users/logOutFromServer", {}, { root: true })
                } else {
                    error.response.data.statusCode = error.response.status
                    return error.response.data
                }
            }
            return {}
        }
    },

    async downloadlangaugesMapperFromServer(context, payload = {}) {
        try {
            let resp = await axios.get(`${Constants.languageURL}/download-mapper/${payload.languageId}`, payload);
            if (Constants.acceptedStatusCodes.includes(resp.status)) {
                resp.data.statusCode = resp.status
                return resp.data;
            } else {
                throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
            }
        } catch (error) {
            console.error(
                `[downloadlangaugesMapperFromServer][Store][Error occured while getting tags List--->${error}]`
            );
            if (error.response) {
                if (error.response.status == 401) {
                    return context.dispatch("users/logOutFromServer", {}, { root: true })
                } else {
                    error.response.data.statusCode = error.response.status
                    return error.response.data
                }
            }
            return {}
        }
    },
    async getSpecificLanguage(context,payload={}){
        try {
          let resp = await axios.get(`${Constants.allLanguagesURL}/${payload._id}`, payload);
          if (Constants.acceptedStatusCodes.includes(resp.status)) {
              resp.data.statusCode = resp.status
              return resp.data;
          } else {
              throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
          }
        } catch (error) {
            console.error(
                `[getSpecificLanguage][Store][Error occured while getting language info--->${error}]`
            );
            if (error.response) {
                if (error.response.status == 401) {
                    return context.dispatch("logOutFromServer")
                } else {
                    error.response.data.statusCode = error.response.status
                    return error.response.data
                }
            }
            return {}
        }
    },
    
    async updateLanguageWithResetFromServe(context, payload = {}) {
        try {
            let resp = await axios.put(`${Constants.allLanguagesURL}/${payload.languageId}`, payload.params);
            console.log("payloadpayload", payload, resp)
            if (Constants.acceptedStatusCodes.includes(resp.status)) {
                console.log(
                    `[updateLanguageWithResetFromServe][Store][User update resp-->${resp.status}]`
                );
                resp.data.statusCode = resp.status
                    // if (payload.params._id == context.state.loggedInUserInfo._id) {
                    //     context.dispatch("updateLoggedInUserInfo", {})
                    // }
                return resp.data;
            } else {
                throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
            }
        } catch (error) {
            console.error(
                `[updateLanguageWithResetFromServe][Store][Error occured while updating user--->${error}]`
            );
            if (error.response) {
                if (error.response.status == 401) {
                    return context.dispatch("logOutFromServer")
                } else {
                    error.response.data.statusCode = error.response.status
                    return error.response.data
                }
            }
            return {}
        }
    },

    async getAssetKeywordSearchInFilters(context,payload={}){
        try {
          let resp = await axios.get(`${Constants.assetKeywordSearchInFiltersURL}`, payload);
          if (Constants.acceptedStatusCodes.includes(resp.status)) {
              resp.data.statusCode = resp.status
              return resp.data;
          } else {
              throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
          }
        } catch (error) {
            console.error(
                `[getAssetKeywordSearchInFilters][Store][Error occured while getting language info--->${error}]`
            );
            if (error.response) {
                if (error.response.status == 401) {
                    return context.dispatch("logOutFromServer")
                } else {
                    error.response.data.statusCode = error.response.status
                    return error.response.data
                }
            }
            return {}
        }
    },

    async getLDAPConfigurationInfoFromServer(context, payload = {}) {
        try {
            let resp = await axios.get(`${Constants.LDAPConfigURL}`, payload);
            if (Constants.acceptedStatusCodes.includes(Number(resp.status))) {
                resp.data.statusCode = resp.status
                return resp.data;
            } else {
                throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
            }
        } catch (error) {
            console.error(
                `[getLDAPConfigurationInfoFromServer][Store][Error occured while getting tags List--->${error}]`
            );
            if (error.response) {
                if (error.response.status == 401) {
                    return context.dispatch("users/logOutFromServer", {}, { root: true })
                } else {
                    error.response.data.statusCode = error.response.status
                    return error.response.data
                }
            }
            return {}
        }
    },



    async updateLDAPConfigurationToServer(context, payload = {}) {
        try {
            let resp = await axios.put(`${Constants.LDAPConfigURL+'/'+payload.params.id}`, payload.params);
            if (Constants.acceptedStatusCodes.includes(resp.status)) {
                console.log(
                    `[updateReportsSettings][Store][User update resp-->${resp.status}]`
                );
                resp.data.statusCode = resp.status
                    // if (payload.params._id == context.state.loggedInUserInfo._id) {
                    //     context.dispatch("updateLoggedInUserInfo", {})
                    // }
                return resp.data;
            } else {
                throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
            }
        } catch (error) {
            console.error(
                `[updateReportsSettings][Store][Error occured while updating user--->${error}]`
            );
            if (error.response) {
                if (error.response.status == 401) {
                    return context.dispatch("logOutFromServer")
                } else {
                    error.response.data.statusCode = error.response.status
                    return error.response.data
                }
            }
            return {}
        }
    },

    async getAllReportsToBeMailed(context, payload = {}) {
        try {
            let resp = await axios.get(`${Constants.allReportsList}`, payload);
            if (Constants.acceptedStatusCodes.includes(Number(resp.status))) {
                resp.data.statusCode = resp.status
                return resp.data;
            } else {
                throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
            }
        } catch (error) {
            console.error(
                `[getAllReportsToBeMailed][Store][Error occured while getting tags List--->${error}]`
            );
            if (error.response) {
                if (error.response.status == 401) {
                    return context.dispatch("users/logOutFromServer", {}, { root: true })
                } else {
                    error.response.data.statusCode = error.response.status
                    return error.response.data
                }
            }
            return {}
        }
    },

};